import type { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap'

/**
 * Converts { year: number, month: number, day: number } to a string
 * YYYY-mm-dd
 * @param date The ng bootstrap date to be formatted
 * @returns string
 */
export function formatNgbDateStruct(date: NgbDateStruct): string {
  const month = String(date.month).length < 2 ? `0${date.month}` : date.month
  const day = String(date.day).length < 2 ? `0${date.day}` : date.day
  return `${date.year}-${month}-${day}`
}

/**
 * Converts YYYY-mm-dd to NgbDateStruct or returns null
 * @param formattedDate YYYY-mm-dd
 */
export function createNgbDateStruct(formattedDate: string): NgbDateStruct | null {
  if (!formattedDate) return null
  const isoDateRegex = /^(?<year>\d{4})-(?<month>\d{2})-(?<day>\d{2})/
  const matches = formattedDate.match(isoDateRegex)
  if (!matches?.groups?.year) return null
  if (!matches?.groups?.month) return null
  if (!matches?.groups?.day) return null

  return {
    year: Number(matches.groups.year),
    month: Number(matches.groups.month),
    day: Number(matches.groups.day)
  }
}
